<template>
  <div>
    <!-- <section class="catg-area">
      <div class="container">
        <CategoryList />
      </div>
    </section> -->
    <section class="client-listing-area">
      <div class="client-listing-head-fluid" style="padding-bottom: 5px;">
        <div class="container">
          <div class="client-listing-head">
            <SearchBar />
          </div>
          <!-- ends client-listing-head -->
        </div>
      </div>
      <!-- ends client-listing-head-fluid -->
      <div class="client-listing-detail-fluid">
        <div class="container px-0">
          <div class="client-listing-detail">
            <AiMatchedList v-if="aiMode" />
            <ApplicantList v-else-if="defaultSearchLoaded" />
          </div>
          <!-- ends client-listing-detail -->
        </div>
      </div>
      <!-- ends client-listing-detail-fluid -->
    </section>
  </div>
</template>

<script>
import ApplicantList from '@/components/dashboard/applicants/ApplicantList.vue';
import AiMatchedList from '@/components/dashboard/applicants/AiMatchedList.vue';
import SearchBar from '@/components/dashboard/applicants/SearchBar.vue';
// import CategoryList from '@/components/dashboard/category/CategoryList.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Applicants',
  components: { SearchBar, ApplicantList, AiMatchedList },
  
  data() {
    return {
      defaultSearchLoaded: false,
    };
  },

  async mounted() {
    // App.vue dispatches loadCurrentUser fire-and-forget on app boot — it isn't awaited by
    // route navigation, so on a fresh/direct hit to this URL isReviewer could still be
    // reading its default (false), wrongly redirecting a real HR/admin account. Await it
    // here explicitly so the check below is always based on real data.
    await this.loadCurrentUser();
    if (!this.isReviewer) {
      this.$router.push('/under-review');
      return;
    }
    if (!this.defaultLoaded) {
      await this.loadCurrentUserDefaultSearch();
    }
    this.defaultSearchLoaded = true;
    this.changeBodyBackground();
  },

  methods: {
    ...mapMutations({
      setStatusModel: 'setStatusModel',
      setProfileModalState: 'setProfileModalState',
      resetApplicantListState: 'resetApplicantListState',
      resetAiMatchingState: 'resetAiMatchingState',
    }),
    ...mapActions([
      'loadCurrentUserDefaultSearch',
      'loadCurrentUser',
    ]),
  },

  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
      user: 'getCurrentUser',
      defaultLoaded: 'getDefaultLoaded',
      aiMode: 'getAiMode',
    }),
  },

  beforeRouteLeave(to, from, next) {
    this.resetApplicantListState();
    this.resetAiMatchingState();
    this.setProfileModalState(false);
    this.setStatusModel([]);
    this.defaultSearchLoaded = false;
    next();
  },
};
</script>